<template>
  <DpplSvg
    data-png-ignore
    file-name="widget-download"
    class="widget-csv-download"
    @click="downloading ? null : downloadWidgetCSV()"
  />
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { ref } from 'vue';
import { useAppAuthData } from '@/stores/app/authData';
import { storeToRefs } from 'pinia';
import { useDatePicker } from '@/stores/filters/datePicker';
import { useTracking } from '@/stores/tracking/tracking';
import { useRoute } from 'vue-router';
import { useDemographicSurveyReport } from '@/stores/insights/demographicSurveyReport';
import { wait } from '@/helpers/wait';

const props = defineProps({
  isSourceTable: {
    type: Boolean,
    default: false,
  },
});

const { authData } = storeToRefs(useAppAuthData());
const { projectName } = authData.value;
const route = useRoute();

const { downloadReqFillRateCSV, downloadSourceTableCSV } = useDemographicSurveyReport();

const { dateRange } = storeToRefs(useDatePicker());

const downloading = ref(false);

const downloadSourceCsv = async () => {
  downloadSourceTableCSV({
    projectName,
    dateRange: dateRange.value,
  });

  await wait(2000);
};

const downloadWidgetCSV = async () => {
  useTracking().insightsDownloadReport({
    reportName: route.name,
    downloadType: 'Individual Widgets',
    downloadLocation: 'Individual Widget',
    fileType: 'CSV',
    widgetName: props.isSourceTable ? 'Source Data Table' : 'Requisition Data Table',
  });

  downloading.value = true;

  if (props.isSourceTable) await downloadSourceCsv();
  else {
    await downloadReqFillRateCSV({
      routerQuery: route.query || {},
      projectName,
      dateRange: dateRange.value,
    });
  }

  downloading.value = false;
};
</script>

<style lang="less" scoped>
.widget-csv-download {
  cursor: pointer;

  :deep(path:first-child) {
    stroke: @grey-500;
  }

  :deep(path:last-child) {
    fill: @grey-500;
  }

  &:hover {
    :deep(path:first-child) {
      stroke: @grey-900;
    }

    :deep(path:last-child) {
      fill: @icon-darkest;
    }
  }
}
</style>
